import React from 'react';
import appLogo from "../../assets/svg/app-logo.svg";
import { Link } from 'react-router-dom';
const Logo = ({width}) => {
  return (
    <Link to ="/">
       <img
                src={appLogo}
                width={width || "250px"}
                alt="appLogo"
              />
    </Link>
  )
}
export default Logo;